// 그룹 판정의 정본은 플랫폼 표(`deliveryPlatform.js`)다 — 여기서는 받아 쓰고, 종전 import 경로를 위해 다시 내보낸다
import { platformGroup } from './deliveryPlatform.js'

export { platformGroup }

export const DEDUCTION_KEYS = [
  'delivery_fee',
  'store_delivery_tip',
  'service_commission',
  'card_commission',
  'platform_discount',
  'store_discount',
  'vat',
  'ad_cost',
  'instant_discount',
]

export function hasServerDeductionTotal(source = {}) {
  return source.deduction_amount !== undefined && source.deduction_amount !== null
}

// 정산 구성요소 부호 컨벤션: 음수는 가게가 '받는' 가산(요기요 배달요금), 양수는 '떼이는' 차감.
// 차감 폭포/표에서 두 성격을 물리적으로 분리 표시하기 위한 SSOT 판정자.
export function deductionDirection(value) {
  return Number(value || 0) < 0 ? 'credit' : 'debit'
}

export function rowPlatform(source = {}, fallback = '') {
  return source.platform || source.platform_display_group || source.delivery_app_tp || fallback
}

export function deductionComponentValue(
  source = {},
  key,
  platform = '',
  serverSigned = hasServerDeductionTotal(source)
) {
  const value = Number(source[key] || 0)
  if (serverSigned) return value

  // 서버 signed 계약의 폴백 사본이다 — `IntegratedSalesService.signedDeliveryFeeSql`·`signedPlatformDiscountSql`
  // (`DeliverySettlementMapper.deductionTotal` 과 같은 규칙): 배달요금은 요기요만 가산(음수), 플랫폼 할인은 배민·요기요만
  // 차감이고 **그 밖(쿠팡이츠·땡겨요·오더톡·기타)은 서버도 `ELSE` 갈래**다. 서버가 갈래를 늘리면 여기도 같이 늘린다.
  const group = platformGroup(platform)
  if (key === 'delivery_fee' && group === 'YOGIYO') return -Math.abs(value)
  // 가게배달팁(배민 MP)은 가게 '수취' — 플랫폼 무관 항상 credit(음수). 서버 signed 계약과 동일.
  if (key === 'store_delivery_tip') return -Math.abs(value)
  if (key === 'platform_discount' && !['BAEMIN', 'YOGIYO'].includes(group)) return 0
  return value
}

export function deductionComponents(source = {}, platform = '', serverSigned = hasServerDeductionTotal(source)) {
  return DEDUCTION_KEYS.reduce((acc, key) => {
    acc[key] = deductionComponentValue(source, key, platform, serverSigned)
    return acc
  }, {})
}

export function deductionTotal(source = {}, platform = '') {
  if (hasServerDeductionTotal(source)) {
    return Number(source.deduction_amount || 0)
  }
  return Object.values(deductionComponents(source, platform, false)).reduce((sum, value) => sum + Number(value || 0), 0)
}

export function aggregateDeductionComponents(sources = []) {
  return sources.reduce(
    (acc, source) => {
      const components = deductionComponents(source, rowPlatform(source), hasServerDeductionTotal(source))
      DEDUCTION_KEYS.forEach((key) => {
        acc[key] += Number(components[key] || 0)
      })
      return acc
    },
    DEDUCTION_KEYS.reduce((acc, key) => {
      acc[key] = 0
      return acc
    }, {})
  )
}
